(function () {
    'use strict';

    angular.module("imApp").factory("consignmentLinesService", ['$ihttp', function ($ihttp) {
        let service = {
            listConsignmentLines: function (parms) {
                return $ihttp.post({
                    method: 330,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
